import Swal from 'sweetalert2';

export const toast = (icon, title) => {
  Swal.fire({ icon, title, toast: true, position: 'top-end', showConfirmButton: false, timer: 2500, timerProgressBar: true });
};

export const confirmAction = async (title, text) => {
  const result = await Swal.fire({ title, text, icon: 'warning', showCancelButton: true, confirmButtonColor: '#C62828', cancelButtonColor: '#7A828A', confirmButtonText: 'Confirmer', cancelButtonText: 'Annuler' });
  return result.isConfirmed;
};

export const promptReason = async (title) => {
  const result = await Swal.fire({ title, input: 'text', inputPlaceholder: 'Saisissez le motif...', showCancelButton: true, confirmButtonText: 'Valider', cancelButtonText: 'Annuler', inputValidator: (v) => { if (!v) return 'Motif requis'; } });
  return result.isConfirmed ? result.value : null;
};

export const showError = (msg) => {
  Swal.fire({ icon: 'error', title: 'Erreur', text: msg, confirmButtonColor: '#0A192F' });
};

export const showSuccess = (title) => {
  Swal.fire({ icon: 'success', title, timer: 2000, showConfirmButton: false });
};

export default Swal;